import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SesionService, StorageService } from 'core-tsi';
import { ToastService } from 'ng-components-tsi';

export const accesoRutasGuard: CanActivateFn = (route, _state) => {

  const router = inject(Router)
  const sesion = inject(SesionService)
  const toast = inject(ToastService)

  const codmod = route.data['codmod']
  const codacc = route.data['codacc']
  if (codmod == null || codacc == null) return true

  const accesos = sesion.getAccesos()
  const hasAccess = !!StorageService.obtenerAcceso(accesos, codmod, codacc)

  if (!hasAccess) {
    toast.error('Acceso denegado', 'No tienes permiso para acceder a esta sección')
    router.navigate(['/atajos'])
    return false
  }
  return true;

}
